import React from 'react';
import { Button, Container, Row } from 'reactstrap';

import Header from 'components/Headers/Header.js';
import CardStatics from 'components/Card/Card';

const Index = () => {
  return (
    <>
      <Header />
      <Container
        className='mt--7'
        fluid
        style={{
          display: 'grid',
          gap: '20px',
        }}
      >
        <Row>
          <CardStatics name={'Vendas'}>
            <Button color='danger' href='/admin/sale' size='sm'>
              Ver todos
            </Button>
          </CardStatics>
          <CardStatics name={'Clientes'}>
            <Button color='success' href='/admin/client' size='sm'>
              Ver todos
            </Button>
          </CardStatics>
          <CardStatics name={'Rotas'}>
            <Button color='warning' href='/admin/route' size='sm'>
              Ver todos
            </Button>
          </CardStatics>
          <CardStatics name={'Produtos'}>
            <Button color='info' href='/admin/product' size='sm'>
              Ver todos
            </Button>
          </CardStatics>
          <CardStatics name={'Relatório'}>
            <Button color='primary' href='/admin/report' size='sm'>
              Ver todos
            </Button>
          </CardStatics>
        </Row>
      </Container>
    </>
  );
};

export default Index;
